export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">联系我们</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">任何问题或合作需求，欢迎随时联系我们</p>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row gap-8 lg:gap-14">
          <div className="flex-1 space-y-5">
            <h3 className="text-lg font-semibold text-foreground-900 mb-4">联系方式</h3>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800 mb-0.5">商务合作与投稿</div>
                <span className="text-sm text-foreground-500">contact@51chigua.com</span>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-customer-service-line text-lg text-accent-500"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800 mb-0.5">用户反馈与建议</div>
                <span className="text-sm text-foreground-500">feedback@51chigua.com</span>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-error-warning-line text-lg text-secondary-500"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800 mb-0.5">入口问题反馈</div>
                <span className="text-sm text-foreground-500">report@51chigua.com</span>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground-900 mb-4">快速留言</h3>
            <form
              className="space-y-3"
              onSubmit={(e) => {
                e.preventDefault();
                alert('感谢留言！我们会尽快回复。');
              }}
            >
              <input
                type="text"
                name="name"
                placeholder="你的昵称"
                className="w-full px-4 py-2.5 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <input
                type="email"
                name="email"
                placeholder="你的邮箱"
                className="w-full px-4 py-2.5 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <textarea
                name="message"
                placeholder="留言内容（不超过500字）"
                maxLength={500}
                rows={3}
                className="w-full px-4 py-2.5 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors resize-none"
              ></textarea>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden={true}
                readOnly
                className="hp-field"
              />
              <button
                type="submit"
                className="w-full px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                发送留言
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}